import { CopyIcon } from '@chakra-ui/icons';
import { Input, InputGroup, InputRightElement } from '@chakra-ui/react';
import { css } from '@emotion/react';
import { useCallback } from 'react';
import { copyToClipboard } from 'src/utils/copyToClipboard';

export const InputCopy = ({ value, onCopy, copyHandler, ...props }) => {
  const handleCopy = useCallback(() => {
    const currentHandler = copyHandler || copyToClipboard;
    currentHandler(value);

    if (onCopy) onCopy(value);
  }, [copyHandler, onCopy, value]);

  return (
    <InputGroup
      onClick={handleCopy}
      cursor="pointer"
      size={{ base: 'md', lg: 'lg' }}
      {...props}
    >
      <Input
        pointerEvents="none"
        value={value}
        bg="white"
        // A workaround for this issue: https://github.com/chakra-ui/chakra-ui/issues/5703
        css={css({
          paddingInlineEnd: '40px !important',
        })}
        readOnly
      />
      <InputRightElement h="full" w={10}>
        <CopyIcon />
      </InputRightElement>
    </InputGroup>
  );
};
